<template>
  <tr>
    <td class="name-cell">
      <small>({{ sub.userdata_id }})</small>
      {{ sub.fullname }}
    </td>
    <td>
      {{ sub.username }}
      <p>
        <small>({{ sub.CardOwnerID }})</small>
      </p>
    </td>
    <td>
      {{ subType }}
      <div v-if="sub.cupon && sub.cupon.cupon">
        <small class="has-text-success">{{ sub.cupon.cupon }}</small>
      </div>
    </td>
    <td>
      {{ nextPayment }}
      <br />
      <button class="button is-small is-info" @click="openModal">
        הוסף ימי מתנה
      </button>
    </td>
    <td>
      <button class="button is-warning" v-if="isToken" @click="cancelToken">
        בטל טוקן
      </button>
      <span v-if="!isToken">אין טוקן</span>
    </td>
    <td>
      <button
        v-if="parseInt(sub.account_status) === 1"
        class="button is-danger"
        @click="cancelAccount"
      >
        השעה מנוי
      </button>
      <button
        v-if="parseInt(sub.account_status) === 0"
        class="button"
        @click="activateAccount"
      >
        חדש מנוי
      </button>
    </td>

    <td>
      <button class="button is-success" v-if="isToken" @click="chargeNow">
        חייב עכשיו
      </button>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    sub: Object
  },
  computed: {
    subType() {
      let subtype = "";
      if (this.sub.sub_type === "1") {
        subtype = "מנוי חודשי";
      }

      if (this.sub.sub_type === "2") {
        subtype = "מנוי שנתי";
      }

      if (this.sub.sub_type === "3") {
        subtype = "מורה";
      }

      if (this.sub.sub_type === "4") {
        subtype = "מנוי מתנה";
      }

      if (this.sub.sub_type === "5") {
        subtype = "עיתונאי";
      }
      return subtype;
    },
    nextPayment() {
      const date = new Date(this.sub.sub_next_payment);
      return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
    },
    isToken() {
      const noToken = [
        "gift-no-token",
        "teacher-no-token",
        "no-token-canceled"
      ];

      if (noToken.indexOf(this.sub.token) > -1 || this.sub.token === "") {
        return false;
      }
      return true;
    }
  },
  methods: {
    cancelAccount() {
      this.$store.dispatch("cancelAccount", this.sub);
    },
    activateAccount() {
      this.$store.dispatch("activateAccount", this.sub);
    },
    cancelToken() {
      this.$store.dispatch("cancelToken", this.sub);
    },
    openModal() {
      this.$store.dispatch("openModal", this.sub);
    },
    chargeNow() {
      this.$store.dispatch("sendCharge", this.sub);
    }
  }
};
</script>

<style lang="scss">
.name-cell {
  position: relative;

  small {
    position: absolute;
    bottom: 3px;
    right: 3px;
    color: cadetblue;
  }
}
</style>
